import { FormProps } from 'antd/es/form';
import { ModalProps } from 'antd/es/modal';
import { ModalStyles } from 'rc-dialog/lib/IDialogPropTypes';
import React, { useCallback, useRef } from 'react';
import { Button, Col, Modal, Row, Typography } from 'components';
import styles from '../formModal/styles.module.scss';

interface CustomModalProps extends ModalProps {
  children: React.ReactNode;
  onSubmit?: FormProps['onFinish'];
  onCancel?: () => void;
  okText?: string;
  obBtnDanger?: boolean;
  disableOkBtn?: boolean;
  isLoading?: boolean;
  cancelText?: string;
  footerButtons?: React.ReactNode;
}

const modalStyles: ModalStyles = {
  body: {
    maxHeight: '60vh',
    overflowY: 'auto',
    margin: '-20px -24px',
  },
  header: {
    height: 64,
  },
};

export const FMGModal: React.FC<CustomModalProps> = (props) => {
  const {
    children,
    onSubmit,
    onCancel,
    okText = 'Save',
    obBtnDanger = false,
    cancelText = 'Cancel',
    disableOkBtn = false,
    isLoading = false,
    footerButtons,
    ...modalProps
  } = props;
  const modalBodyRef = useRef<HTMLDivElement>(null); // Ref to modal body content

  const resetScroll = useCallback(() => {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }
  }, []);

  const handelCancel = useCallback(() => {
    onCancel && onCancel();
    resetScroll();
  }, [onCancel, resetScroll]);
  return (
    <Modal
      closable={false}
      width={680}
      {...modalProps}
      title={
        modalProps?.title ? <Typography className={styles.form_modal_title}>{modalProps?.title}</Typography> : undefined
      }
      onCancel={handelCancel}
      styles={{ ...modalStyles }}
      bodyProps={{ ref: modalBodyRef }}
      centered
      footer={
        modalProps.footer ? (
          modalProps.footer
        ) : (
          <Row gutter={[0, 20]}>
            <Col span={24}>
              <Row wrap={false} className="gap-8" style={{ margin: '24px 0 12px' }}>
                {footerButtons ? (
                  footerButtons
                ) : (
                  <>
                    <Button block size="large" onClick={handelCancel}>
                      {cancelText}
                    </Button>
                    <Button
                      loading={isLoading}
                      block
                      size="large"
                      disabled={disableOkBtn}
                      type="primary"
                      onClick={onSubmit}
                      danger={obBtnDanger}
                    >
                      {okText}
                    </Button>
                  </>
                )}
              </Row>
            </Col>
          </Row>
        )
      }
    >
      <div className={styles.modal_body}>{children}</div>
    </Modal>
  );
};
